(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sf-double-cleanse"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.initialised === 'true') return;
      root.dataset.initialised = 'true';
      const bundleButtons = [...root.querySelectorAll('[data-sf-bundle]')];
      const singleButtons = [...root.querySelectorAll('[data-sf-single]')];
      const buttons = [...bundleButtons, ...singleButtons];
      const status = root.querySelector('[role="status"]');
      const bundleIds = [root.dataset.balmVariant, root.dataset.gelVariant].filter(Boolean);

      buttons.forEach((button) => {
        const label = button.querySelector('[data-label]');
        button.dataset.originalLabel = label ? label.textContent.trim() : '';
        button.dataset.initiallyDisabled = button.disabled ? 'true' : 'false';
      });

      const restore = () => buttons.forEach((button) => {
        const disabled = button.dataset.initiallyDisabled === 'true';
        button.disabled = disabled;
        button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
        const label = button.querySelector('[data-label]');
        if (label) label.textContent = button.dataset.originalLabel;
      });

      const add = async (ids, activeButton) => {
        if (!ids.length) { if (status) status.textContent = root.dataset.unavailable; return; }
        buttons.forEach((button) => { button.disabled = true; button.setAttribute('aria-disabled', 'true'); });
        const loading = activeButton.dataset.loadingLabel || root.dataset.loading;
        const label = activeButton.querySelector('[data-label]');
        if (label) label.textContent = loading;
        if (status) status.textContent = loading;
        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', credentials: 'same-origin',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: ids.map((id) => ({ id, quantity: 1 })) })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          restore();
          if (status) status.textContent = root.dataset.error;
        }
      };

      bundleButtons.forEach((button) => button.addEventListener('click', () => {
        if (bundleIds.length !== 2) { if (status) status.textContent = root.dataset.unavailable; return; }
        add(bundleIds, button);
      }));
      singleButtons.forEach((button) => button.addEventListener('click', () => add(button.dataset.variant ? [button.dataset.variant] : [], button)));
    };
    document.querySelectorAll('[data-sf-cleanse]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-sf-cleanse]').forEach(init));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sft-aromaticna-nega"] && !Shopify.designMode) return;
  try {
    
(()=>{
 const initialize=root=>{
  if(root.dataset.ready)return;root.dataset.ready='true';
  const labels=JSON.parse(root.querySelector('[data-aroma-labels]').textContent);
  const boxes=[...root.querySelectorAll('[data-aroma-buy]')];
  const prefix=(root.dataset.root||'/').replace(/\/?$/, '/');
  const money=cents=>new Intl.NumberFormat(root.dataset.locale||'sl-SI',{style:'currency',currency:root.dataset.currency||'EUR'}).format(cents/100);
  const state=new Map();
  const all=selector=>[...root.querySelectorAll(selector)];
  boxes.forEach(box=>state.set(box.dataset.handle,{price:Number(box.dataset.price),compare:Number(box.dataset.compare),id:box.dataset.variant,available:box.dataset.available==='true',single:box.dataset.single==='true'}));
  const refreshOffer=()=>{
   const handles=boxes.map(x=>x.dataset.handle),bundle=state.get(handles[3]);
   const validBundle=bundle&&bundle.single&&Number.isFinite(bundle.price)&&Number.isFinite(bundle.compare);
   const discount=validBundle&&bundle.compare>bundle.price?bundle.compare-bundle.price:0;
   all('[data-bundle-discount]').forEach(el=>el.hidden=discount<=0);
   all('[data-bundle-compare-price]').forEach(el=>el.textContent=money(validBundle?bundle.compare:0));
   all('[data-discount-amount]').forEach(el=>el.textContent=money(Math.max(0,discount)));
   all('[data-discount-percent]').forEach(el=>el.textContent=discount>0?Math.round(discount/bundle.compare*100):0);
   const singles=handles.slice(0,3).map(x=>state.get(x));
   const valid=singles.length===3&&singles.every(x=>x&&x.single&&Number.isFinite(x.price))&&validBundle;
   const total=valid?singles.reduce((sum,x)=>sum+x.price,0):0,advantage=valid?total-bundle.price:0;
   all('[data-bundle-advantage]').forEach(el=>el.hidden=!valid||advantage<=0);
   all('[data-bundle-basis]').forEach(el=>el.hidden=!valid);
   if(!valid)return;
   all('[data-separate-price]').forEach(el=>el.textContent=money(total));
   all('[data-advantage-amount]').forEach(el=>el.textContent=money(Math.max(0,advantage)));
   all('[data-advantage-percent]').forEach(el=>el.textContent=total>0?Math.round(Math.max(0,advantage)/total*100):0);
  };
  const prior=async(box,variant)=>{
   const priorEl=box.querySelector('[data-prior]'),badge=box.querySelector('[data-sale]'),compareEl=box.querySelector('[data-item-compare]');
   const interludeBadges=all('[data-interlude-discount="'+box.dataset.handle+'"]');
   priorEl.hidden=true;badge.hidden=true;compareEl.hidden=true;
   interludeBadges.forEach(el=>el.hidden=true);
   if(!(variant.compare_at_price>variant.price)||root.dataset.currency!=='EUR'||root.dataset.country!=='SI')return;
   try{
    const response=await fetch('/apps/omnibus/price/lowest/'+variant.id+'?market='+encodeURIComponent(root.dataset.market||'si'),{signal:AbortSignal.timeout(7000)});
    if(!response.ok||response.status===204)return;
    const data=await response.json(),reference=Number(data.price);
    if(!Number.isFinite(reference)||reference<=0||box.dataset.variant!==String(variant.id))return;
    priorEl.querySelector('span').textContent=money(reference);priorEl.hidden=false;
    if(reference>variant.price){const percent=Math.round((variant.compare_at_price-variant.price)/variant.compare_at_price*100);compareEl.textContent=money(variant.compare_at_price);compareEl.hidden=false;badge.textContent='−'+percent+'%';badge.hidden=false;interludeBadges.forEach(el=>{el.querySelector('[data-interlude-discount-value]').textContent=percent;el.hidden=false;});}
   }catch(e){}
  };
  let last=0;
  const refresh=async()=>{
   if(Date.now()-last<60000)return;last=Date.now();
   await Promise.all(boxes.map(async box=>{
    if(!box.dataset.handle)return;
    try{
     const response=await fetch(prefix+'products/'+encodeURIComponent(box.dataset.handle)+'.js',{signal:AbortSignal.timeout(7000),cache:'no-store'});
     if(!response.ok)return;const product=await response.json();const variant=product.variants.find(v=>String(v.id)===box.dataset.variant)||product.variants.find(v=>v.available)||product.variants[0];
     if(!variant)return;
     const single=product.variants.length===1&&product.variants[0].title==='Default Title';
     state.set(box.dataset.handle,{price:variant.price,compare:Number(variant.compare_at_price)||0,id:variant.id,available:variant.available,single});
     box.dataset.variant=variant.id;box.dataset.price=variant.price;box.dataset.compare=Number(variant.compare_at_price)||0;
     all('[data-aroma-price]').forEach(el=>{if(el.dataset.aromaPrice===box.dataset.handle)el.textContent=money(variant.price)});
     const button=box.querySelector('button[type=submit]');
     if(button){button.disabled=!variant.available||!single;box.querySelector('[name=id]').value=variant.id;button.querySelector('[data-button-label]').textContent=!single?labels.choose:!variant.available?labels.sold:(boxes.indexOf(box)===3?labels.bundle:labels.add);}
     box.querySelector('[data-stock]').textContent=variant.available?labels.stock:labels.sold;
     await prior(box,variant);
    }catch(e){}
   }));refreshOffer();
  };
  boxes.forEach(box=>{
   const form=box.querySelector('form');if(!form)return;
   form.addEventListener('submit',async event=>{
    event.preventDefault();const button=form.querySelector('button');if(button.disabled)return;
    const label=button.querySelector('[data-button-label]'),old=label.textContent,status=box.querySelector('[role=status]');button.disabled=true;label.textContent=labels.pending;status.textContent='';
    try{
     const response=await fetch(prefix+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:form.querySelector('[name=id]').value,quantity:1}]})});
     const data=await response.json();if(!response.ok)throw new Error(data.description||labels.error);
     window.location.assign(prefix+'cart');
    }catch(error){status.textContent=error.message||labels.error;button.disabled=false;label.textContent=old;}
   });
  });
  const sticky=root.querySelector('[data-aroma-sticky]');
  if('IntersectionObserver' in window){let heroVisible=true,endVisible=false;const sync=()=>sticky.hidden=heroVisible||endVisible;const obs=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.target.classList.contains('ar-hero'))heroVisible=entry.isIntersecting;else endVisible=entry.isIntersecting});sync()},{threshold:0});obs.observe(root.querySelector('.ar-hero'));obs.observe(root.querySelector('.ar-close'));}
  document.addEventListener('visibilitychange',()=>{if(!document.hidden&&root.isConnected)refresh()});
  refresh();
 };
 document.querySelectorAll('[data-aroma-root]').forEach(initialize);
 document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-aroma-root]').forEach(initialize));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sft-therapy"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(scope) {
    scope.querySelectorAll('[data-sft-care]').forEach(root => {
      if (root.dataset.scReady) return;
      root.dataset.scReady = 'true';
      const controls = root.querySelector('.sc-filters');
      const buttons = [...root.querySelectorAll('[data-sc-filter]')];
      const products = [...root.querySelectorAll('[data-sc-product]')];
      const result = root.querySelector('[data-sc-results]');
      const empty = root.querySelector('[data-sc-empty]');
      if (!controls || !result || !empty) return;
      function filter(value) {
        let count = 0;
        products.forEach(product => {
          const visible = value === 'all' || product.dataset.group === value;
          product.hidden = !visible;
          if (visible) count++;
        });
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.scFilter === value)));
        result.textContent = `${result.dataset.label} ${count}`;
        empty.hidden = count > 0;
      }
      controls.hidden = false;
      controls.addEventListener('click', event => {
        const button = event.target.closest('[data-sc-filter]');
        if (button && controls.contains(button)) filter(button.dataset.scFilter);
      });
      filter('all');
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();


  } catch(e) { console.error(e); }
})();
})();
